export default "__VITE_ASSET__elO0sx5n__"